import React from 'react';

// 把 text 中命中 query 各关键词的部分包成 <mark> 高亮。返回 React 节点数组。
export function highlightText(text, query) {
  if (!text || !query) return text;
  const terms = query.trim().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return text;
  const escaped = terms.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const re = new RegExp(`(${escaped.join('|')})`, 'gi');
  const lowerTerms = terms.map((t) => t.toLowerCase());
  return text.split(re).map((part, i) =>
    lowerTerms.includes(part.toLowerCase())
      ? <mark key={i}>{part}</mark>
      : part
  );
}
